export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const downloadImage = (dataUrl: string, filename: string): void => {
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Google DriveリンクをWebで表示可能な直リンクに変換
export const convertGoogleDriveUrl = (url: string): string => {
  if (!url) return url;
  
  // Google Driveの共有リンクパターンをチェック
  const drivePattern = /drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
  const match = url.match(drivePattern);
  
  if (match && match[1]) {
    const fileId = match[1];
    return `https://drive.google.com/uc?export=view&id=${fileId}`;
  }
  
  return url;
};

export const generateEmbedCode = (sliderId: string, beforeImage: string, afterImage: string): string => {
  // Google DriveリンクがあればBase64の場合はそのまま、URLの場合は変換
  const beforeUrl = beforeImage.startsWith('data:') ? beforeImage : convertGoogleDriveUrl(beforeImage);
  const afterUrl = afterImage.startsWith('data:') ? afterImage : convertGoogleDriveUrl(afterImage);
  
  const id = `ba${sliderId}`;
  
  const embedHtml = `<div id="${id}" style="position:relative;width:100%;max-width:100%;overflow:hidden">
  <img src="${afterUrl}" style="width:100%;display:block" alt="After">
  <div id="${id}b" style="position:absolute;top:0;left:0;width:50%;height:100%;overflow:hidden;border-right:2px solid #fff">
    <img src="${beforeUrl}" style="width:200%;max-width:none" alt="Before">
  </div>
  <div id="${id}h" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:30px;height:30px;background:rgba(255,255,255,0.9);border-radius:50%;box-shadow:0 0 8px rgba(0,0,0,0.3);pointer-events:none"></div>
  <input id="${id}r" type="range" min="0" max="100" value="50" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:ew-resize;margin:0">
</div>
<script>
document.getElementById('${id}r').oninput=function(){
  var v=this.value+'%';
  document.getElementById('${id}b').style.width=v;
  document.getElementById('${id}h').style.left=v;
};
</script>`;
  
  return embedHtml;
};
